"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  HelpQuestionNetwork: ['help-question-network', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.99,7.014a.992.992,0,0,0,.7-.289l1.8-1.777a.253.253,0,0,1,.251-.061A2.506,2.506,0,1,0,19.121,3.3a.252.252,0,0,1-.062.258L17.288,5.3a1,1,0,0,0,.7,1.712Z', 'M21.5,19a2.471,2.471,0,0,0-.8.131.251.251,0,0,1-.258-.061l-1.784-1.8a1,1,0,1,0-1.418,1.409l1.809,1.821a.252.252,0,0,1,.062.252A2.474,2.474,0,0,0,19,21.5,2.5,2.5,0,1,0,21.5,19Z', 'M2.511,5a2.48,2.48,0,0,0,.745-.114.251.251,0,0,1,.251.061l1.8,1.777A1,1,0,1,0,6.713,5.3L4.942,3.554A.252.252,0,0,1,4.88,3.3,2.463,2.463,0,0,0,5.011,2.5,2.5,2.5,0,1,0,2.511,5Z', 'M5.34,17.275l-1.785,1.8a.252.252,0,0,1-.258.061A2.471,2.471,0,0,0,2.5,19a2.5,2.5,0,1,0,2.387,1.756.248.248,0,0,1,.061-.251l1.81-1.821a1,1,0,0,0-1.418-1.41Z', 'M17.99,12.514H18l1.042-.009a.249.249,0,0,1,.225.135,2.5,2.5,0,1,0,0-2.272.25.25,0,0,1-.22.137l-1.061.009a1,1,0,0,0,.009,2Z', 'M.011,11.5A2.5,2.5,0,0,0,4.735,12.64a.251.251,0,0,1,.225-.135L6,12.514h.009a1,1,0,0,0,.009-2l-1.061-.009a.25.25,0,0,1-.22-.137A2.5,2.5,0,0,0,.011,11.5Z', 'M10.490 18.764 A1.500 1.500 0 1 0 13.490 18.764 A1.500 1.500 0 1 0 10.490 18.764 Z', 'M11.99,6.013a4.255,4.255,0,0,0-4.25,4.25,1.25,1.25,0,0,0,2.5,0,1.75,1.75,0,1,1,2.449,1.605,3.253,3.253,0,0,0-1.949,2.979v.416a1.25,1.25,0,0,0,2.5,0v-.416a.752.752,0,0,1,.45-.688,4.25,4.25,0,0,0-1.7-8.146Z']],
  HelpWheel: ['help-wheel', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm9.428,8.666A.25.25,0,0,1,21.193,9H17.337a.253.253,0,0,1-.214-.12,6.05,6.05,0,0,0-2-2A.253.253,0,0,1,15,6.664V2.808a.251.251,0,0,1,.334-.236A10.051,10.051,0,0,1,21.428,8.667ZM12,16a4,4,0,1,1,4-4A4,4,0,0,1,12,16ZM8.666,2.572A.251.251,0,0,1,9,2.808V6.664a.251.251,0,0,1-.12.214,6.05,6.05,0,0,0-2,2A.253.253,0,0,1,6.663,9H2.807A.251.251,0,0,1,2.6,8.9a.247.247,0,0,1-.031-.228A10.051,10.051,0,0,1,8.666,2.572ZM2.572,15.334A.249.249,0,0,1,2.807,15H6.663a.251.251,0,0,1,.214.12,6.05,6.05,0,0,0,2,2,.252.252,0,0,1,.12.214v3.856a.25.25,0,0,1-.334.235A10.051,10.051,0,0,1,2.572,15.334Zm12.762,6.095A.25.25,0,0,1,15,21.194V17.338a.251.251,0,0,1,.12-.214,6.05,6.05,0,0,0,2-2,.251.251,0,0,1,.214-.12h3.856a.249.249,0,0,1,.2.106.245.245,0,0,1,.031.227A10.051,10.051,0,0,1,15.334,21.429Z']],
  HeadphonesCustomerSupport: ['headphones-customer-support', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,14.251a4.493,4.493,0,0,0-3-4.239V9.251a9,9,0,0,0-18,0v.761A4.5,4.5,0,0,0,3,18.5,1.5,1.5,0,0,0,5,17.08V9.251a7,7,0,1,1,14,0V17.08a1.494,1.494,0,0,0,.5,1.1v.568c0,1.474-1.291,2-2.5,2H15.222a2,2,0,1,0,0,2H17c2.649,0,4.5-1.645,4.5-4v-.478A4.5,4.5,0,0,0,24,14.251Z']],
  HeadphonesCustomerSupportQuestion: ['headphones-customer-support-question', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,14a4.493,4.493,0,0,0-3-4.239V9A9,9,0,0,0,3,9v.761a4.5,4.5,0,0,0,0,8.483A1.5,1.5,0,0,0,5,16.83V9A7,7,0,1,1,19,9V16.83a1.494,1.494,0,0,0,.5,1.1V18.5c0,1.474-1.291,2-2.5,2H15.222a2,2,0,1,0,0,2H17c2.649,0,4.5-1.645,4.5-4v-.478A4.5,4.5,0,0,0,24,14Z', 'M10.750 16.751 A1.250 1.250 0 1 0 13.250 16.751 A1.250 1.250 0 1 0 10.750 16.751 Z', 'M9.5,10.5a1.25,1.25,0,0,0,1.25-1.25A1.25,1.25,0,1,1,12.5,10.4a2.918,2.918,0,0,0-1.749,2.673v.555a1.25,1.25,0,0,0,2.5,0v-.555a.417.417,0,0,1,.25-.383A3.75,3.75,0,1,0,8.25,9.251,1.25,1.25,0,0,0,9.5,10.5Z']],
  QuestionHelpMessage: ['question-help-message', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21.5,0H2.5A2.5,2.5,0,0,0,0,2.5V22.985a.5.5,0,0,0,.805.4l5.56-4.277a.5.5,0,0,1,.3-.1H21.5A2.5,2.5,0,0,0,24,16.5V2.5A2.5,2.5,0,0,0,21.5,0ZM12,16.247a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,12,16.247Zm1.6-6.08a1,1,0,0,0-.6.917,1,1,0,0,1-2,0,3,3,0,0,1,1.8-2.75A2,2,0,1,0,10,6.5a1,1,0,1,1-2,0,4,4,0,1,1,5.6,3.666Z']],
  QuestionHelpCircle: ['question-help-circle', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm0,19a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,12,19Zm1.6-6.08a1,1,0,0,0-.6.917,1,1,0,1,1-2,0,3,3,0,0,1,1.8-2.75A2,2,0,1,0,10,9.255a1,1,0,1,1-2,0,4,4,0,1,1,5.6,3.666Z']],
  QuestionHelpSquare: ['question-help-square', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M2.5,0A2.5,2.5,0,0,0,0,2.5v19A2.5,2.5,0,0,0,2.5,24h19A2.5,2.5,0,0,0,24,21.5V2.5A2.5,2.5,0,0,0,21.5,0ZM12,19a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,12,19Zm1.6-6.08a1,1,0,0,0-.6.917,1,1,0,1,1-2,0,3,3,0,0,1,1.8-2.75A2,2,0,1,0,10,9.255a1,1,0,1,1-2,0,4,4,0,1,1,5.6,3.666Z']],
  HeadphonesCustomerSupportHuman: ['headphones-customer-support-human', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,14a4.493,4.493,0,0,0-3-4.239V9A9,9,0,0,0,3,9v.761a4.5,4.5,0,0,0,0,8.483A1.5,1.5,0,0,0,5,16.83V9A7,7,0,1,1,19,9V16.83a1.494,1.494,0,0,0,.5,1.1V18.5c0,1.474-1.291,2-2.5,2H15.222a2,2,0,1,0,0,2H17c2.65,0,4.5-1.645,4.5-4v-.478A4.5,4.5,0,0,0,24,14Z', 'M15.144,14.045a.833.833,0,0,1,.7-.377.823.823,0,0,1,.454.135.833.833,0,0,1,.243,1.154,5.418,5.418,0,0,1-9.08,0,.834.834,0,0,1,1.4-.912,3.75,3.75,0,0,0,6.288,0Z', 'M7.000 9.501 A1.667 1.667 0 1 0 10.334 9.501 A1.667 1.667 0 1 0 7.000 9.501 Z', 'M13.666 9.501 A1.667 1.667 0 1 0 17.000 9.501 A1.667 1.667 0 1 0 13.666 9.501 Z']],
  LaptopHelpMessage: ['laptop-help-message', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,20.5a.5.5,0,0,0-.5-.5H21.75a.25.25,0,0,1-.25-.25V15.5a1,1,0,1,0-2,0v4.25a.25.25,0,0,1-.25.25H4.75a.25.25,0,0,1-.25-.25V9.167A.667.667,0,0,1,5.167,8.5H7.5a1,1,0,1,0,0-2H5.167A2.669,2.669,0,0,0,2.5,9.167V19.751a.25.25,0,0,1-.25.25H.5a.5.5,0,0,0-.5.5A3.5,3.5,0,0,0,3.5,24h17A3.5,3.5,0,0,0,24,20.5Z', 'M10.5,14a.51.51,0,0,0,.215-.048L14.1,12.34a.25.25,0,0,1,.226.006A6.564,6.564,0,1,0,17.434,0,6.432,6.432,0,0,0,11,6.568a6.665,6.665,0,0,0,.659,3.106.253.253,0,0,1,0,.223l-1.614,3.389A.5.5,0,0,0,10.5,14Zm9.25-8.75A2.253,2.253,0,0,1,17.5,7.5a.75.75,0,0,1,0-1.5.75.75,0,1,0-.75-.75.75.75,0,1,1-1.5,0,2.25,2.25,0,0,1,4.5,0ZM17.5,10a.75.75,0,1,1,.75-.75A.75.75,0,0,1,17.5,10Z']],
  UserQuestion: ['user-question', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21.428,9.857a7.243,7.243,0,0,1-.721-1.451C20.706,3.144,15.844,0,11.143,0a9.925,9.925,0,0,0-10,10.062c0,3.6,1.346,6.276,4,7.958V23.5a.5.5,0,0,0,.5.5h10a.5.5,0,0,0,.5-.5V20.523c1.739-.018,2.8-.209,3.573-.981.836-.836.955-3.34.962-4.528.3,0,.684.006,1.016-.008a1.24,1.24,0,0,0,.963-.519,1.222,1.222,0,0,0,.19-.743l0-.138C22.931,12.49,22.133,11.091,21.428,9.857ZM11.5,17.5A1.5,1.5,0,1,1,13,16,1.5,1.5,0,0,1,11.5,17.5Zm1.6-6.08a1,1,0,0,0-.6.917,1,1,0,1,1-2,0,3,3,0,0,1,1.8-2.75A2,2,0,1,0,9.5,7.755a1,1,0,0,1-2,0,4,4,0,1,1,5.6,3.666Z']],
  QuestionHelpMessageAlternate: ['question-help-message-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M20.5,0H3.5A3.5,3.5,0,0,0,0,3.5V23a1,1,0,0,0,1.588.809l5.171-3.761A.253.253,0,0,1,6.906,20H20.5A3.5,3.5,0,0,0,24,16.5V3.5A3.5,3.5,0,0,0,20.5,0ZM22,16.5A1.5,1.5,0,0,1,20.5,18H6.5a1,1,0,0,0-.588.191L2.4,20.747a.247.247,0,0,1-.26.021A.251.251,0,0,1,2,20.545V3.5A1.5,1.5,0,0,1,3.5,2h17A1.5,1.5,0,0,1,22,3.5Z', 'M10.500 15.500 A1.500 1.500 0 1 0 13.500 15.500 A1.500 1.500 0 1 0 10.500 15.500 Z', 'M12,3.254a4,4,0,0,0-4,4,1,1,0,0,0,2,0,2,2,0,1,1,2.8,1.833,3,3,0,0,0-1.8,2.75,1,1,0,0,0,2,0,1,1,0,0,1,.6-.917A4,4,0,0,0,12,3.254Z']],
  BrowserUserHelpMessage: ['browser-user-help-message', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M8.929,4.079a.251.251,0,0,0-.035-.225.249.249,0,0,0-.2-.1H3.5A3,3,0,0,0,.5,6.7c0,.017,0,16.052,0,16.052a1,1,0,0,0,2,0V8.251a.5.5,0,0,1,.5-.5H8.282a.25.25,0,0,0,.249-.272C8.511,7.239,8.5,7,8.5,6.751A8.493,8.493,0,0,1,8.929,4.079Z', 'M15,22.751a1,1,0,1,0,2,0V15.5a.251.251,0,0,0-.243-.25A8.518,8.518,0,0,1,15.3,15.08a.251.251,0,0,0-.3.245Z', 'M16.934,13.384a6.567,6.567,0,0,0,0-13.133A6.432,6.432,0,0,0,10.5,6.818a6.665,6.665,0,0,0,.659,3.106.253.253,0,0,1,0,.223l-.87,1.826-.744,1.563a.5.5,0,0,0,.451.715.51.51,0,0,0,.215-.048l1.563-.745L13.6,12.59a.25.25,0,0,1,.226.006A6.534,6.534,0,0,0,16.934,13.384ZM19.25,5.5A2.253,2.253,0,0,1,17,7.751a.75.75,0,0,1,0-1.5.75.75,0,1,0-.75-.75.75.75,0,1,1-1.5,0,2.25,2.25,0,0,1,4.5,0ZM17,8.751a.75.75,0,1,1-.75.75A.75.75,0,0,1,17,8.751Z', 'M6.670 17.251 A2.000 2.000 0 1 0 10.670 17.251 A2.000 2.000 0 1 0 6.670 17.251 Z', 'M8.67,20.251a3.594,3.594,0,0,0-3.294,2.317.5.5,0,0,0,.47.683h5.647a.5.5,0,0,0,.471-.683A3.594,3.594,0,0,0,8.67,20.251Z']],
  HeadphonesCustomerSupportHuman1: ['headphones-customer-support-human-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12.643,11.341a1.689,1.689,0,1,0,1.7,1.689A1.7,1.7,0,0,0,12.643,11.341Z', 'M16.53,2.178a.5.5,0,0,1-.289-.293A2.892,2.892,0,0,0,13.532,0H11.754A2.892,2.892,0,0,0,9,2.013a.5.5,0,0,1-.286.311A8.212,8.212,0,0,0,3.3,9.6a2.013,2.013,0,0,1-.215.832c-.147.289-.347.638-.512.928-.7,1.235-1.5,2.633-1.423,3.75l0,.137a1.223,1.223,0,0,0,.189.742,1.247,1.247,0,0,0,.965.521c.173.007.364.01.551.01a.5.5,0,0,1,.5.5V19a2.5,2.5,0,0,0,2.5,2.5h1.5a.5.5,0,0,1,.5.5v1.5a.5.5,0,0,0,.5.5h10a.5.5,0,0,0,.5-.5V19.792a.5.5,0,0,1,.22-.415c2.509-1.69,3.78-4.314,3.78-7.814A9.939,9.939,0,0,0,16.53,2.178ZM12.978,16.987a1,1,0,0,0-.559.229,10.559,10.559,0,0,1-3.8,2.1.5.5,0,0,0-.265.181,1.249,1.249,0,0,1-1,.5h-.5a1.25,1.25,0,0,1,0-2.5h.5a1.236,1.236,0,0,1,.706.22.5.5,0,0,0,.441.063,8.48,8.48,0,0,0,1.995-.99.25.25,0,0,0,0-.419,3.94,3.94,0,0,1,.131-6.751.5.5,0,0,0,.247-.431V2.883A.886.886,0,0,1,11.754,2h1.778a.886.886,0,0,1,.889.882v6.31a.5.5,0,0,0,.248.431,3.952,3.952,0,0,1-1.691,7.363Z']]
};
exports["default"] = _default;